import { IconProps } from '@/context/global/types/icon';
import { cn } from '@/context/global/utils/cn';

const IconLock = ({ className, width = 14, height = 17 }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 15 18"
      fill="currentColor"
      className={cn('text-ais-green', className)}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.38379 4.76758C2.38379 3.50314 2.88609 2.29049 3.78018 1.39639C4.67428 0.502297 5.88693 0 7.15137 0C8.41581 0 9.62847 0.502297 10.5226 1.39639C11.4167 2.29049 11.919 3.50314 11.919 4.76758H12.7135C13.135 4.76758 13.5392 4.93501 13.8373 5.23305C14.1353 5.53108 14.3027 5.93529 14.3027 6.35677V14.3027C14.3027 14.7242 14.1353 15.1284 13.8373 15.4265C13.5392 15.7245 13.135 15.8919 12.7135 15.8919H1.58919C1.16771 15.8919 0.763496 15.7245 0.465464 15.4265C0.167432 15.1284 0 14.7242 0 14.3027V6.35677C0 5.93529 0.167432 5.53108 0.465464 5.23305C0.763496 4.93501 1.16771 4.76758 1.58919 4.76758H2.38379ZM7.15137 1.58919C7.99433 1.58919 8.80277 1.92406 9.39883 2.52012C9.99489 3.11618 10.3298 3.92462 10.3298 4.76758H3.97298C3.97298 3.92462 4.30785 3.11618 4.90391 2.52012C5.49998 1.92406 6.30841 1.58919 7.15137 1.58919ZM8.74056 9.53516C8.74056 9.81412 8.66712 10.0882 8.52764 10.3297C8.38816 10.5713 8.18755 10.7719 7.94597 10.9114V11.919C7.94597 12.1297 7.86225 12.3318 7.71324 12.4808C7.56422 12.6298 7.36211 12.7135 7.15137 12.7135C6.94063 12.7135 6.73852 12.6298 6.58951 12.4808C6.44049 12.3318 6.35677 12.1297 6.35677 11.919V10.9114C6.05383 10.7365 5.81706 10.4665 5.6832 10.1433C5.54934 9.82008 5.52586 9.46175 5.6164 9.12384C5.70694 8.78594 5.90645 8.48735 6.18398 8.27439C6.4615 8.06142 6.80155 7.94598 7.15137 7.94597C7.57285 7.94597 7.97707 8.1134 8.2751 8.41143C8.57313 8.70946 8.74056 9.11368 8.74056 9.53516Z"
        fill="#B2D234"
      />
    </svg>
  );
};

export default IconLock;
